import { createSlice } from '@reduxjs/toolkit';
import _ from "lodash"

const initialState = {
    arrangeOrder: 'asc',
    arrangeKey: 'CreatedOn',
    getEclipseOpsPaymentData: null,
    EclipseOpsPaymentList: [],
    isLoading: false,
    initiateLoading: false,
    LastEvaluatedKey: null,
    LastPage: false,
    eclipseServiceFee: null,
    btnLoading: false,
    manualPaymentMethodsList: [],
    fsPayPOHistoryList: [],
    deleteLoading:false,
    fileUploadLoading:false,
    removeFileLoading:false,
    downloadRequestLoading:false
}

export const EclipseOpsPaymentLoadReducer = createSlice({
    name: 'eclipseOpsPaymentLoadReducer',
    initialState,
    reducers: {
        getEclipseOpsPaymentSuccess: (state, action) => {
            state.isLoading = true;
            state.getEclipseOpsPaymentData = action.payload;
            state.initiateLoading = false;
        },
        getEclipseOpsPaymentFailure: (state, action) => {
            state.isLoading = false;
            state.getEclipseOpsPaymentData = null;
        },
        updateIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        updateDeleteLoading: (state, action) => {
            state.deleteLoading = action.payload
        },
        updateInitiateLoading: (state, action) => {
            state.initiateLoading = action.payload
        },
        updateEclipseOpsPaymentList: (state, action) => {
            // state.EclipseOpsPaymentList.push(...action.payload)
            const updatedList = [...state.EclipseOpsPaymentList,...action.payload]
            const uniqueList = _.uniqBy(updatedList,"RecID")
            state.EclipseOpsPaymentList = uniqueList
            state.isLoading = false
        },
        clearEclipseOpsPaymentList: (state, action) => {
            state.EclipseOpsPaymentList = []
        },
        updateLastEvaluatedKey: (state, action) => {
            state.LastEvaluatedKey = action.payload
        },
        updateLastPage: (state, action) => {
            state.LastPage = action.payload
        },
        updateRealTimePaymentData: (state, action) => {
            const updatedList = [action.payload, ...state.EclipseOpsPaymentList.filter(item => item.RecID !== action.payload.RecID)]
            const uniqueList = _.uniqBy(updatedList,"RecID")
            state.EclipseOpsPaymentList = uniqueList
        },
        updateEclipseServiceFee: (state, action) => {
            state.eclipseServiceFee = action.payload
        },
        updateBtnLoading: (state, action) => {
            state.btnLoading = action.payload
        },
        updateManualPaymentMethodsList: (state, action) => {
            state.manualPaymentMethodsList = action.payload;
        },
        updatedFsPayPOHistory: (state, action) => {
            state.isLoading = false;
            state.fsPayPOHistoryList = action.payload;
        },
        updateFileUploadLoading: (state, action) => {
            state.fileUploadLoading = action.payload
        },
        updateRemoveFileLoading: (state, action) => {
            state.removeFileLoading = action.payload
        },
        updateDownloadRequestLoading: (state, action) => {
            state.downloadRequestLoading = action.payload
        },
    }
});

export const { getEclipseOpsPaymentSuccess, updateIsLoading, getEclipseOpsPaymentFailure, updateInitiateLoading, updateEclipseOpsPaymentList, updateLastEvaluatedKey, clearEclipseOpsPaymentList, updateLastPage, updateRealTimePaymentData, updateEclipseServiceFee, updateBtnLoading, updateManualPaymentMethodsList, updatedFsPayPOHistory, updateDeleteLoading, updateFileUploadLoading, updateRemoveFileLoading, updateDownloadRequestLoading } = EclipseOpsPaymentLoadReducer.actions;

// Selectors
export const getEclipseOpsPaymentLoadselector = (state) => {
    return state.eclipseOpsPaymentLoadReducer;
};

export default EclipseOpsPaymentLoadReducer.reducer;